module.exports = __webpack_public_path__ + "static/media/transaction.0e6f6699.png";